import {AuthenticatedModel} from '@/models/authenticated.model';
import * as jwt from 'jsonwebtoken';
import moment from 'moment'
import {authState} from '@/utils/store-acessor';

export function authenticated(): boolean {

  const saved = localStorage.getItem('credentials');
  const credentials: AuthenticatedModel = saved && JSON.parse(saved);

  if (!!credentials?.access_token) {
    const token = jwt.decode(credentials.access_token);
    if (token) {
      // @ts-ignore
      const exp = token.exp * 1000;
      const isValid = moment().isBefore(moment(exp));
      if (!isValid) {
        authState.logout();
      }
      return isValid
    }
    return false
  }
  return false;
}
